const video = {

	ready(event) {
		// let code = event.target.i.attributes['data-video'].nodeValue
		// let endpoint = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${code}&format=json`
		event.target.setVolume(0)
		video.play(event)
	},

	change(event) {
		if (event.data === YT.PlayerState.ENDED) {
			video.play(event)
		}
	},

	pause(event) {
		if ( event.hasOwnProperty('target') ) {
			event.target.pauseVideo()
		} else {
			event.pauseVideo()
		}
	},

	play(event) {
		if ( event.hasOwnProperty('target') ) {
			event.target.playVideo()
		} else {
			event.playVideo()
		}
	},

	stop(event) {
		if ( event.hasOwnProperty('target') ) {
			event.target.stopVideo()
		} else {
			event.stopVideo()
		}
	}

}


class Slideshow extends Utilities {

	// ===========================================================================
	// Default Settigs
	// ===========================================================================

	get defaults() {
    return {
			navigation : 'slideshow-navigation', // Navigation element tag
			counter    : 'slideshow-counter',    // Counter element tag
			slide      : 'slide-image',          // Slide element tag
			active     : 'current',              // Class name applied to the active/current slide
			autoplay   : false,                   // Auto play slideshow on page load
			duration   : 8000,                   // How long each slide should last in miliseconds
			loop       : 1,                      // How many times the slideshow should loop
			speed      : 1000                    // The speed of the transition of each slide
    }
  }

	// ===========================================================================
	// Constructor
	// ===========================================================================

	constructor(...settings) {

		super()

		this.timer = null;

		this.manage(settings, {
			element  : (setting) => { this.container = setting },
			object   : (setting) => { this.settings = this.merge(this.defaults, setting) }
		})

		// Navigation click handlers -----------------------------------------------

		this._navigation = $(this.settings.navigation)
		this._counter = {
			container : $(this.settings.counter),
			current   : $(this.settings.counter).find('span:first-of-type'),
			total     : $(this.settings.counter).find('span:last-of-type')
		}

		this._navigation.find('.prev').on('click', () => { this.prev(); clearInterval(this.timer); this.timer = null; })
		this._navigation.find('.next').on('click', () => { this.next(); clearInterval(this.timer); this.timer = null; })
		this._navigation.find('.view').on('click', (event) => {
			Scroll.to(0)
			clearInterval(this.timer); this.timer = null;
			if ( body.hasClass('fullscreen')) {
				// Go back to normal view
				body.removeClass('fullscreen')
				setTimeout(()=> {
					$(event.currentTarget).text('Full Screen')
					body.removeClass('locked')
				}, 1000)
			} else {
				// Go to gallery view
				$(event.currentTarget).text('Close')
				body.addClass('fullscreen locked')

			}
		})

		// Other -------------------------------------------------------------------
		this.videos = {}
		this.animating = false;
		CustomProperties.set('speed', (this.settings.speed / 1000) + 's', this.container)

	}

	// ===========================================================================
	// Update the slideshow with new content
	// ===========================================================================

	/**
	 * Update the slideshow with new content
	 *
   * @param {Object} data Pass in collection of slide dom elements, or it's parent container
   *
	*/

	update(data = false) {

		// Find all image slides from the slideshow data passed through
		let slides = data ? data.find(`> *:not(slideshow-navigation)`) : this.slides

		if ( this.timer ) {
			clearInterval(this.timer); 
			this.timer = null;
		}

		// Determine the current elements. Both from before and after this update
		let current = {
			old : this.current.length ? this.current : false,
			new : slides.filter(`.${this.settings.active}`).length ? slides.filter(`.${this.settings.active}`) : false
		}

		CustomProperties.remove('background-color', body)
		this.container.removeClass('faded gradient none transparent')

		if ( data.data('background-colour') ) {
			CustomProperties.set('background-color', data.data('background-colour'), body)
		}

		if ( data.attr('data-backdrop') ) {
			this.container.addClass(data.attr('data-backdrop'))
		}

		// Remove all but the current slide from the container
		this.slides.not(`.${this.settings.active}`).remove()

		// Manage slide injections
		if ( slides.length ) {

			this.container.attr('data-count', slides.length)

			// Adding multiple slides to the slideshow -------------------------------

			if ( slides.length == 1 ) {
				//console.log(`Adding just one slide to the slideshow`)
				this._navigation.addClass('hide')
			} else {
				//console.log(`Adding ${slides.length} slides to the slideshow`)
				this._navigation.removeClass('hide')
			}

			this.container.append(slides)

			let videoSlide = slides.filter('.video')

			// videoSlide.addClass('hide')
			
			if ( videoSlide.length ) {

				videoSlide = videoSlide[0]
				let videoId = $(videoSlide).attr('data-video')

				if ( videoId.includes('youtu') ) {
					videoId = videoId.match(/src="([^"]*)"/)[1].split('?v=')[1];
					$(videoSlide).attr('data-video', videoId)
				}

			  this.videos[videoId] = new YT.Player('player', {
			    videoId: videoId,
					playerVars:{'autoplay':1, 'rel':0, 'loop':1, 'controls': 0, 'playsinline':1, 'iv_load_policy':3, 'disablekb':1, 'modestbranding':1, 'origin':window.location.origin},
					events: {
          	'onReady': video.ready,
            'onStateChange': video.change
          }
			  })
			} else {
				if ( slides.length > 1 && this.settings.autoplay && document.body.id != 'home') {
					this.timer = setInterval(() => {
						this.next(false)
					}, this.settings.duration)
				} 
			}

			if ( !firstvisit ) {

				if ( current.old ) {

					// console.log('Remove the old current slide')

					current.old.removeClass(this.settings.active)

					this.direction('ltr', () => {
						if ( current.new.length ) { current.new.removeClass('animating') }
						current.old.remove()
					})

					if ( current.new.length ) { setTimeout(() => {current.new.addClass('animating')}, 100) }

			    if ( current.new.length ) { current.new.addClass(this.settings.active) }

				} else  {

					//console.log('Animate in the first slide from blue')

					this.container.attr('data-direction', 'ltr')

					if ( current.new.length ) { setTimeout(() => {current.new.addClass('animating')}, 100) }

					setTimeout(() => {
						this.container.attr('data-direction','')
						if ( current.new.length ) { current.new.removeClass('animating') }
					}, this.settings.speed + 100);

				}

			}

			// Manage the counter numbers

			this._counter.current.text(1)
			this._counter.total.text(slides.length)

		} else {

			// Adding zero slides to the slideshow -----------------------------------

			//console.log(`There are no slides to add`)

			this._navigation.addClass('hide')

			if ( !firstvisit ) {
				this.direction('rtl', () => {
					if ( current.old !== false ) {
						current.old.remove()
					}
				})
			}

		}
	}

	// ===========================================================================
	// Getters
	// ============================================================================

	get slides() {
		return this.container.find(this.settings.slide)
	}

	get current() {
		return this.slides.filter(`.${this.settings.active}`)
	}

	// ===========================================================================
	// Counter
	// ===========================================================================

	/**
	 * Update the counter with a new value. Classes are added and removed to assist
	 * with the animation handle via the CSS.
	 *
	 * @param {Number} value The new current number
	*/

	set counter(value) {
		this._counter.current.addClass('out')
		setTimeout(() => {
			this._counter.current.toggleClass('out in').text(value)
			setTimeout(() => {
				this._counter.current.removeClass('in')
			}, 200);
		}, 200);
	}

	// ===========================================================================
	// Next & Prev Actions
	// ===========================================================================

	next() {

		if ( !this.animating ) {

			this.checkVideoSlide(this.current, 'pause', this.settings.speed)

			let current = this.current.removeClass(this.settings.active).next(this.settings.slide)

			this.direction('ltr', () => current.removeClass('animating'))

			setTimeout(() => {current.addClass('animating')}, 100)

	    if(current.length){
	      current.addClass(this.settings.active)
	    } else {
	      current = this.slides.first().addClass(this.settings.active)
	    }

			this.checkVideoSlide(current, 'play')

			this.counter = current.index() + 1
		}

	}

	prev() {

		if ( !this.animating ) {

			this.checkVideoSlide(this.current, 'pause', this.settings.speed)

			let current = this.current.removeClass(this.settings.active).prev(this.settings.slide)

			this.direction('rtl', () => current.removeClass('animating'))

			setTimeout(() => {current.addClass('animating')}, 100)

	    if(current.length){
	      current.addClass(this.settings.active)
	    } else {
	      current = this.slides.last().addClass(this.settings.active)
	    }

			this.checkVideoSlide(current, 'play')

			this.counter = current.index() + 1

		}
	}

	// ===========================================================================
	// Direction handling
	// ===========================================================================

	/**
	 * This handles the timing of class assignments to the slideshow container
   *
   * @param {String} dir Direction the slide should animate to/from
   * 										'rtl' Right to Left, or 'ltr' Left ro Right.
   *
   * @param {Function} func Trigger a callback function when animation has finished
	*/

	direction(dir, func) {
		this.animating = true;
		this.container.attr('data-direction', dir)
		setTimeout(() => {
			this.container.attr('data-direction','')
			func()
			this.animating = false;
		}, this.settings.speed + 100);
	}

	// ===========================================================================
	// Manage Video Slides
	// ===========================================================================

	checkVideoSlide(current = this.current, state = 'play', delay = 0) {

		if ( current.hasClass('video') ) {
			setTimeout(() => {
				let videoId = $(current[0]).attr('data-video')
				// if ( videoId.includes('youtu') ) {
				// 	videoId = videoId.match(/src="([^"]*)"/)[1].split('?v=')[1];
				// 	$(videoSlide).attr('data-video', videoId)
				// }

				switch(state) {
				  case 'play':
						video.play(this.videos[videoId])
				  break;
				  case 'pause':
						video.pause(this.videos[videoId])
				  break;
					case 'stop':
						video.stop(this.videos[videoId])
				  break;
				}
			}, delay)
		}

	}

}
